import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReviewRulesPage } from './ReviewRules';
import '~/styles/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ReviewRulesPage />
  </React.StrictMode>
);
